import React from 'react';

import { buttons, colors, typography } from '@pray/shared/components/foundations';
import Button from '@pray/shared/components/ui/Button';
import Text from '@pray/shared/components/ui/Text';

import styles from './ErrorMessageDialog.module.scss';

export default function ErrorMessageDialog({
  title,
  message,
  viewName = 'Checkout Error',
  closeButtonText = 'Close',
  cancelButtonText = 'Cancel',
  onCancel,
  onClose,
}) {
  return (
    <div data-viewname={viewName} className={styles.overlay}>
      <div className={styles.dialog}>
        <div className={styles.content}>
          <div className={styles.header}>
            <ErrorIcon />
            <Text variant={typography.heading_2xl}>{title}</Text>
          </div>
          <Text className={styles.message} color={colors.text_secondary}>
            {message}
          </Text>
        </div>

        <div className={styles.buttons}>
          <Button variant={buttons.variant.primary} onClick={onClose}>
            {closeButtonText}
          </Button>
          <Button variant={buttons.variant.secondary} onClick={onCancel}>
            {cancelButtonText}
          </Button>
        </div>
      </div>
    </div>
  );
}

const ErrorIcon = () => (
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1" y="1.5" width="38" height="38" rx="19" stroke="#EA4345" strokeWidth="2" />
    <path
      d="M12.3736 11.4599C11.9831 11.0694 11.3499 11.0694 10.9594 11.4599C10.5689 11.8504 10.5689 12.4836 10.9594 12.8741L18.5856 20.5003L10.9594 28.1266C10.5689 28.5171 10.5689 29.1502 10.9594 29.5408C11.3499 29.9313 11.9831 29.9313 12.3736 29.5408L19.9998 21.9145L27.6261 29.5408C28.0166 29.9313 28.6498 29.9313 29.0403 29.5408C29.4308 29.1502 29.4308 28.5171 29.0403 28.1266L21.4141 20.5003L29.0403 12.8741C29.4308 12.4836 29.4308 11.8504 29.0403 11.4599C28.6498 11.0694 28.0166 11.0694 27.6261 11.4599L19.9998 19.0861L12.3736 11.4599Z"
      fill="#FF5B59"
    />
  </svg>
);
